"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var List_1 = __importDefault(require("@mui/material/List"));
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var OnboardingStepIcon_1 = __importDefault(require("components/Icons/OnboardingStepIcon"));
var OnboardingAccordion_1 = __importDefault(require("containers/Onboarding/styles/OnboardingAccordion"));
var StepTitle_1 = __importDefault(require("containers/Onboarding/styles/StepTitle"));
var Accordion_1 = __importDefault(require("shared/components/Accordion"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion/AccordionDetails"));
var single_1 = require("utils/selectors/single");
var SubStep_1 = __importDefault(require("./SubStep"));
var SubStepsGroup = function (_a) {
    var _b, _c;
    var step = _a.step, setStep = _a.setStep, isDone = _a.isDone;
    // const company = useSelector(selectMyCompany);
    var label = step.label, disabledCondition = step.disabledCondition, ModalComponent = step.ModalComponent, subSteps = step.subSteps, subStepsMap = step.subStepsMap, stepConf = step.stepConf;
    // const isDone = company?.rechargeSetupSteps?.includes(label);
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var _d = __read(react_1.default.useState(false), 2), isModalOpen = _d[0], setIsModalOpen = _d[1];
    var _e = __read(react_1.default.useState(true), 2), isModalFullyClosed = _e[0], setIsModalFullyClosed = _e[1];
    var doneSteps = (_c = (_b = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.rechargeSetupSubSteps) === null || _b === void 0 ? void 0 : _b.filter(function (subStep) { return subSteps === null || subSteps === void 0 ? void 0 : subSteps.includes(subStep); })) !== null && _c !== void 0 ? _c : [];
    react_1.default.useEffect(function () {
        if (doneSteps.length === (subSteps === null || subSteps === void 0 ? void 0 : subSteps.length) && !isDone) {
            setStep();
        }
    }, [doneSteps.length]);
    react_1.default.useEffect(function () {
        if (!isModalOpen) {
            var t_1 = setTimeout(function () { return setIsModalFullyClosed(!isModalOpen); }, 500);
            return function () { return clearTimeout(t_1); };
        }
        setIsModalFullyClosed(!isModalOpen);
        return undefined;
    }, [isModalOpen]);
    return ((0, jsx_runtime_1.jsxs)(ListItem_1.default, __assign({ disablePadding: true, sx: { ml: 2 } }, { children: [(0, jsx_runtime_1.jsxs)(Accordion_1.default, __assign({ hideBorders: true, disabled: !!disabledCondition }, { children: [(0, jsx_runtime_1.jsxs)(OnboardingAccordion_1.default, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mr: 4 }, { children: (0, jsx_runtime_1.jsx)(OnboardingStepIcon_1.default, { isDone: isDone }) })), (0, jsx_runtime_1.jsxs)(StepTitle_1.default, __assign({}, stepConf, { children: [label, " ", " (".concat(doneSteps.length, " of ").concat(subSteps === null || subSteps === void 0 ? void 0 : subSteps.length, ")")] }))] }), (0, jsx_runtime_1.jsx)(AccordionDetails_1.default, __assign({ sx: { pl: 4 } }, { children: (0, jsx_runtime_1.jsx)(List_1.default, __assign({ disablePadding: true }, { children: (subSteps && subStepsMap) && (subSteps === null || subSteps === void 0 ? void 0 : subSteps.map(function (subStep) { return (0, jsx_runtime_1.jsx)(SubStep_1.default, { subStep: subStep, subStepsMap: subStepsMap }, subStep); })) })) }))] })), ModalComponent && !isModalFullyClosed && ((0, jsx_runtime_1.jsx)(ModalComponent, { open: isModalOpen, onClose: function () { return setIsModalOpen(false); } }))] })));
};
exports.default = SubStepsGroup;
